import { Container, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useAboutPage, getAboutSectionByKey } from '@/hooks/useAboutPage';
import { getAboutImage } from '@/utils/imageUrl';

const CompanyStory = ({ sectionData: propSectionData }) => {
  const { sections, loading } = useAboutPage();
  const section = propSectionData || getAboutSectionByKey(sections, 'company_story');
  
  const bgColor = section?.background_color || 'light';
  const bgEffect = section?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  
  if (loading && !propSectionData) {
    return (
      <section className={`py-5 py-lg-6 ${bgClass} about-section company-story-section`}>
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Container>
      </section>
    );
  }
  
  if (!section) {
    return null;
  }
  
  // Use section data if available, otherwise fallback to hardcoded content
  const primaryImage = section.items?.[0]?.image || 'pictures/about/story-our-team.jpg';
  const secondaryImage = section.items?.[1]?.image || 'pictures/about/story-team.jpg';
  const title = section.title || 'Our Story';
  const introText = section.intro_text || '';
  const content = section.content || {};
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';
  
  return (
    <section className={`py-5 py-lg-6 ${bgClass} about-section company-story-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        {/* Header Section */}
        <Row className="mb-4">
          <Col>
            {title && <h2 className="sec-title mb-3">{title}</h2>}
            {introText ? (
              <div className="lead intro-text mb-0" dangerouslySetInnerHTML={{ __html: introText }} />
            ) : (
              <div className="lead intro-text mb-0">
                <p className="mb-3">
                  Representing tour operators in Eastern Crete for the past 40 years, we maintain excellent 
                  working relations with owners of accommodations and count as one of the most reliable incoming 
                  travel agencies in Eastern Crete.
                </p>
                <p className="mb-3">
                  And the reason behind this is that, while we are an independently owned family business, 
                  we work together as a team and therefore value all our business partners; hence most of them 
                  we have enjoyed long-term partnerships with and today maintain great friendships.
                </p>
                <p className="mb-0">
                  In dealing with the customers, we are able to offer quality services in very competitive rates, 
                  and more so, always manage to get excellent reviews and keep our guests satisfied by offering 
                  our services with a professional attitude and a friendly smile!
                </p>
              </div>
            )}
          </Col>
        </Row>

        {/* Images and Content */}
        <Row className="g-4 align-items-center mb-4">
          <Col lg={6}>
            <Image 
              src={getAboutImage(primaryImage)} 
              className="rounded-4 shadow-lg w-100" 
              alt={title} 
            />
          </Col>
          <Col lg={6}>
            {content.team_title && <h3 className="h4 fw-bold mb-3" style={{ color: '#000000' }}>{content.team_title}</h3>}
            {content.team_description ? (
              <div className="intro-text mb-0" dangerouslySetInnerHTML={{ __html: content.team_description }} />
            ) : (
              <div className="intro-text mb-0">
                <h3 className="h4 fw-bold mb-3" style={{ color: '#000000' }}>Meet our team</h3>
                <p className="mb-3">
                  Our team consists of over <strong>30 dedicated, multilingual, experienced tourism professionals</strong>, 
                  and as we have been working with most of them for many years, we believe they extend our family!
                </p>
                <p className="mb-0">
                  Besides our main office managers, our team includes as well <strong>customer service representatives 
                  in five (5) languages (English, German, French, Czech, and Polish)</strong> and, along with a group 
                  of professional drivers and tour guides we manage to create trust and a friendly environment to our 
                  mutual customers.
                </p>
              </div>
            )}
          </Col>
        </Row>
        {secondaryImage && (
          <Row className="g-4">
            <Col lg={6} className="order-lg-2">
              <Image 
                src={getAboutImage(secondaryImage)} 
                className="rounded-4 shadow-lg w-100" 
                alt="Our Team" 
              />
            </Col>
            <Col lg={6} className="order-lg-1">
              {/* Additional content can go here if needed */}
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default CompanyStory;
